import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Box,
  Button,
  Input,
  VStack,
  Heading,
  Text,
  Container,
  Card,
} from "@chakra-ui/react";
import { Field } from "@chakra-ui/react";

import { useAppDispatch, useAppSelector } from "../store/hooks";
import { forgotPassword } from "../store/slices/authSlice";
import { toaster } from "../components/ui/toaster";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.auth);
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!/^\S+@\S+$/.test(email)) {
      toaster.create({ title: "Invalid email", type: "error", duration: 3000 });
      return;
    }

    try {
      const result = await dispatch(forgotPassword({ email })).unwrap();
      toaster.create({
        title: "Code sent",
        description: result.message || "Check your email",
        type: "success",
        duration: 5000,
      });
      navigate("/reset-password", { state: { email } });
    } catch (error: any) {
      toaster.create({
        title: "Request failed",
        description: error,
        type: "error",
        duration: 5000,
      });
    }
  };

  return (
    <Box className="min-h-screen flex items-center justify-center" bg="gray.50">
      <Container maxW="md" py={12}>
        <VStack mb={6} textAlign="center">
          <Heading size="xl">Forgot Password?</Heading>
          <Text color="gray.600">Enter your email to receive a reset code</Text>
        </VStack>

        <Card.Root>
          <Card.Body p={8}>
            <form onSubmit={handleSubmit}>
              <VStack gap={4}>
                <Field.Root required width="full">
                  <Field.Label>Email</Field.Label>
                  <Input
                    type="email"
                    placeholder="you@pharmasee.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Field.Root>

                <Button
                  type="submit"
                  colorScheme="blue"
                  width="full"
                  loading={loading}
                  mt={2}>
                  Send Reset Code
                </Button>

                <Text textAlign="center">
                  <Link
                    to="/login"
                    className="text-blue-500 hover:text-blue-600">
                    Back to login
                  </Link>
                </Text>
              </VStack>
            </form>
          </Card.Body>
        </Card.Root>
      </Container>
    </Box>
  );
}
